import { Component, h, Prop } from "@stencil/core";
import { TextProps } from "./f-text-model";
@Component({
  tag: "f-text",
  styleUrl: "f-text.scss",
  shadow: true,
})
export class Text {
  @Prop() tag: TextProps["tag"];
  @Prop() variant: TextProps["variant"];
  @Prop() fontWeight: TextProps["fontWeight"];
  @Prop() margin: TextProps["margin"] = false;

  variantIsTag() {
    return (
      this.variant ===
      ("h1" || "h2" || "h3" || "h4" || "h5" || "h6" || "div" || "span" || "p")
    );
  }

  render() {
    const CustomTag = this.tag || (this.variantIsTag() ? this.variant : "p");

    return (
      <CustomTag
        class={{
          [this.variant]: Boolean(this.variant),
          [this.tag]: !Boolean(this.variant) && Boolean(this.tag),
          p: !Boolean(this.variant) && !Boolean(this.tag),
          [`u-font-${this.fontWeight}`]: Boolean(this.fontWeight),
          ["no-margin"]: !Boolean(this.margin),
        }}
        data-test="text"
      >
        <slot />
      </CustomTag>
    );
  }
}
